<template>
  <div>
      <PageTitle
      title="Incredients"
    
    />
    <v-row>
    
      <v-col cols="12 py-0">
        <v-container fluid>
          <v-row>
            <v-col cols="12" class="d-flex justify-end">
              <permission-control permissionName="Batch Create">
                <v-btn
                  depressed
                  small
                  height="32"
                  class="btn_blue w-100"
                  @click.stop="OpenModal()"
                >
                  <v-icon class="icon_small ma-2">mdi-plus </v-icon>
                  Add
                </v-btn>
              </permission-control>
            </v-col>
          </v-row>
             <v-card>
          <v-row>
         
            <!-- Data table -->
            <v-col cols="12">
              
              <v-data-table
                :items-per-page="paginationOptions.perPage"
                :headers="headers"
                :items="Ingredients"
                hide-default-footer
              >

                <template v-slot:item.image="{ item }">
                   <v-dialog v-model="dialog" max-width="60vw">
                    <img
                      :src="loadimage"
                      alt=""
                      width="100%"
                      @click.stop="dialog = false"
                      
                    />
                  </v-dialog>
            <v-avatar size="32px" item color="primary">
              <img
                      v-if="item.image"
                      height="30"
                      width="30"
                      :src="item.image"
                      style="border-radius: 30%"
                     @mouseover.stop="dialog = true"
                      @mouseover="changeimage(item.image)"
                    />
              <span v-else class="white--text subtitle-2 text-uppercase">{{
                item.name.substring(0, 2)
              }}</span>
            </v-avatar>
          </template>
                <template v-slot:item.created_at="{ item }">{{
                  item.created_at | formatDate
                }}</template>
                <!-- Action -->
                <template v-slot:item.action="{ item }">
                  <list-menu
                    feature="incredient"
                    :item="item"
                    @refreshList="refreshData"
                    editPermission="Category Edit"
                    DeletePermission="Category Edit"
                    @onEditClicked="EditModal(item)"
                    :isEditModal="true"
                  ></list-menu>
                </template>
                <template v-slot:footer="{}">
                  <pagination
                    @paginationOptions="setPaginationOptions"
                    :url="`hms/ingredients`"
                    @response="receiveIngredientsData"
                    ref="pagination"
                    :filter="filter"
                  />
                </template>
              </v-data-table>
            </v-col>

            <v-row> </v-row>
          </v-row>
          </v-card>
        </v-container>
      </v-col>
    </v-row>

    <CreateIngredients
      ref="CreateDesigination"
      :visible="isIngredientsFormVisible"
      @close="CloseModal($event)"
      @afterSave="refreshData()"
    />

    <EditIngredients
      ref="EditIngredients"
      :visible="isEditIngredientsFormVisible"
      :Ingredients="IngredientDatas"
      @close="CloseEditModal($event)"
      @afterSave="refreshData()"
    />
    <!-- </v-container> -->
  </div>
</template>
<script>

import pagination from "../../../shared/components/pagination";
import EditIngredients from "./EditIncredientComponent";
import CreateIngredients from "./CreateIncredientComponent";

export default {
  data: () => ({
    loadimage: "",
    dialog: false,
    paginationOptions: {},
    messages: [],
   
    errors: [],
    IngredientDatas:[],
    isIngredientsFormVisible: false,
    isEditIngredientsFormVisible: false,

    Ingredients: [],

    columns: [
       {
        text: "Image",
        value: "image",
        show: true,
        disabled: false,
       
      },
      {
        text: "Name",
        value: "name",
        show: true,
        disabled: true,
        align: "left",
      },
      {
        text: "Created at",
        value: "created_at",
        show: true,
        disabled: false,
        align: "left",
      },
      {
        text: "Actions",
        value: "action",
        show: true,
        disabled: false,
        align: "left",
      },
    ],
  }),
  components: { EditIngredients, pagination, CreateIngredients },
  filters: {},
  computed: {
    headers: function() {
      return this.columns.filter((item) => item.show == true);
    },
  },
  methods: {
    changeimage(value) {
      this.loadimage = value;
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
 
    receiveIngredientsData(data) {
      
      this.Ingredients = data;
       this.Ingredients.map((u) => {
        if (u.image) {
          u.image = u.image + "?t=" + new Date().getTime();
        }
      });
    },
    OpenModal() {
      
      this.isIngredientsFormVisible = true;
      this.$refs.CreateDesigination.refreshImage();
    },
    CloseModal($event) {
      this.isIngredientsFormVisible = false;
    },
    EditModal(data) {
      this.isEditIngredientsFormVisible = true;

      this.GetIngredientSingle(data.id);
         this.$refs.EditIngredients.refreshImage();
    },
      CloseEditModal($event) {
      this.isEditIngredientsFormVisible = false;
    },
    GetIngredientSingle(id) {
      
      this.$store
        .dispatch(`ingredients/GetSinleIngredients`, id)
        .then((res) => {
          
          this.IngredientDatas = res.data;
            if (this.IngredientDatas.image) {
            this.IngredientDatas.image = this.IngredientDatas.image + "?t=" + Date.now();
          }

          this.refreshData();

          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
  
  
  },
 
};
</script>
